import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import SearchAutocompleteResults from 'components/components/SearchAutocompleteResults/SearchAutocompleteResults';
import { palette, theme } from 'theme';
import pxToEm from 'theme/pxToEm';

export const Backdrop = styled.div<{ open?: boolean }>`
  position: fixed;
  display: ${({ open }) => (open ? 'block' : 'none')};
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 7;
`;

export const AbsoluteContainer = styled.div<{
  open?: boolean;
  topOffset?: number;
}>`
  position: absolute;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  height: fit-content;
  max-height: calc(
    100vh - ${({ topOffset }) => (topOffset ? `${topOffset}px` : pxToEm(113))}
  );
  width: 100%;
  padding: ${`0 ${pxToEm(16)}`};
  z-index: 100;
  background-color: ${theme.palette.common.white};
  overflow: auto;
  margin-top: -4px;

  ${theme.breakpoints.up('md')} {
    padding-left: ${pxToEm(32)};
    padding-right: ${pxToEm(32)};
  }
`;

export const ContentWrapper = styled.div<{
  searchFormRect?: DOMRect;
}>`
  display: flex;
  width: 100%;
  padding-bottom: 1em;

  ${theme.breakpoints.up('lg')} {
    max-width: ${pxToEm(640)};
    align-self: center;

    ${({ searchFormRect }) =>
      searchFormRect &&
      `
            width: ${searchFormRect.width}px;
            max-width: unset;
            align-self: flex-start;
            margin-left: ${searchFormRect.left - 32}px;
        `}
  }
`;

export const AutocompleteResults = styled(SearchAutocompleteResults)<{
  shouldSplitHalf?: boolean;
}>`
  width: 100%;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;

  ${({ shouldSplitHalf }) =>
    shouldSplitHalf
      ? `
        width: 50% !important;
    `
      : ''}
`;

export const SuggestedItemsWrapper = styled.div`
  max-width: 550px;
  width: 50%;
  margin: 20px 0 20px 8px;
  padding-left: 24px;
  border-left: 1px solid ${palette.grey[50]};
`;

export const ProductCell = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  padding: 8px !important;
  border-radius: 12px;
  ${({ isActive }) =>
    isActive &&
    `
        background: #F2F2F2;
        text-decoration: underline;
    `}
  &:hover {
    background: #f2f2f2;
    text-decoration: underline;
  }
`;
